module.exports = "/_next/static/resources/pack-89f0a53721524f5b3f8320351622fdb4.jpg";